import { render, staticRenderFns } from "./searchComponent.vue?vue&type=template&id=f3b6f80a&scoped=true&"
import script from "./searchComponent.vue?vue&type=script&lang=js&"
export * from "./searchComponent.vue?vue&type=script&lang=js&"
import style0 from "./searchComponent.vue?vue&type=style&index=0&id=f3b6f80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b6f80a",
  null
  
)

export default component.exports